import { useState, useRef, useEffect } from 'react';
import { SegmentsContainer, Indicator, SegmentItem } from './style.js';
import { jsx } from '@emotion/react';

var SegmentedControl = _ref => {
  var {
    segmentItems,
    initialActiveId = 1,
    onClick
  } = _ref;
  var itemsCount = segmentItems.length;

  if (itemsCount === 0) {
    return null;
  }

  var initialActiveItem = segmentItems.find(item => item.id === initialActiveId);
  var initialActiveIndex = initialActiveItem ? segmentItems.indexOf(initialActiveItem) : 0;
  var [activeSegmentText, setActiveSegmentText] = useState(() => initialActiveItem ? initialActiveItem.text : segmentItems[0].text);
  var [activeSegmentIndex, setActiveSegmentIndex] = useState(initialActiveIndex);
  var targetRef = useRef(null);
  var [transform, setTransform] = useState('');
  var [targetWidth, setTargetWidth] = useState(0);
  var segmentWidth = 100 / itemsCount;
  useEffect(() => {
    if (targetRef.current) {
      setTargetWidth(targetRef.current.offsetWidth);
      setTransform("translate3d(".concat(targetRef.current.offsetWidth * activeSegmentIndex, "px, 0, 0)"));
    }
  }, [targetRef]);

  var onSegmentClick = (segment, index) => {
    setActiveSegmentText(segment.text);
    setActiveSegmentIndex(index);
    setTransform("translate3d(".concat(targetWidth * index, "px, 0, 0)"));

    if (onClick) {
      onClick(segment);
    }
  };

  return jsx(SegmentsContainer, null, jsx(Indicator, {
    segmentWidth: segmentWidth,
    transform: transform,
    ref: targetRef
  }, activeSegmentText), segmentItems.map((segment, index) => jsx(SegmentItem, {
    segmentWidth: segmentWidth,
    active: index === activeSegmentIndex,
    key: segment.id,
    onClick: () => {
      onSegmentClick(segment, index);
    },
    disabled: index === activeSegmentIndex
  }, segment.text)));
};

export { SegmentedControl };
